<template>
  <div class="login-style" v-if="loginStatus === '1'">
    <div class="login-content" @keyup.13="login">
      <!--<Divider style="color: #fff;font-size: 30px;">数字病理智能诊断系统 IDP-C v1.17</Divider>-->
      <Divider style="color: #fff;font-size: 20px;">
        <div>{{systemName}}</div>
        <div>{{versionNumber}}</div>
      </Divider>
      <Card class="login-card">
<!--        <Select v-model="userName" maxlength="15" size="large" style="width: 70%;text-align: left" @on-change="selectUser"  :placeholder="$t('login.usernamePlaceholder')">-->
<!--          <Option v-for="item in userList" :value="item.label" :key="item.value">{{ item.label }}</Option>-->
<!--        </Select><br/>-->
        <Row>
          <Col span="10" style="height: 250px;">
            <img src="../assets/123.gif" width="320" height="320" style="position: relative;top: -50px;left: 10px;"/>
          </Col>
          <Col span="13" offset="1">
            <Input v-model="userName" maxlength="17"  :placeholder="$t('login.usernamePlaceholder')" style="width: 70%;margin-top: 20px" type="text" size="large" @on-focus="cancelError" /><br/>
            <Input v-model="password" maxlength="17"  :placeholder="$t('login.passwordPlaceholder')" style="width: 70%;margin-top: 20px" type="password" size="large" @on-focus="cancelError">
            </Input><br>
            <div class="error-text" v-if="isShowError">
              <Icon type="md-close-circle" size="20" style="color: #dc3c00" />
              <span>{{errorText}}</span><br>
            </div>
            <div style="text-align: left;margin-top: 4%">
              <Checkbox v-model="isStore" style="margin-left: 15%"  @on-change="rememberPassword">{{$t('login.rememberPassword')}}</Checkbox>
            </div>
            <div class="login-btn">
              <Button type="primary" style="width: 70%; height: 40px; font-size: 16px" @click="login" >{{$t('login.login')}}</Button>
            </div>
          </Col>
        </Row>
      </Card>
    </div>
  </div>
</template>

<script>
import hexsha1 from '../../static/js/hex-sha1'
export default {
  name: 'login',
  data () {
    return {
      $vue: '',
      userId: '',
      isStore: false,
      userList: [],
      systemName: '', // 系统名称
      versionNumber: '', // 版本号
      loginStatus: '', // 是否显示登录页面
      userName: '',
      password: '',
      errorText: '',
      isShowError: false
    }
  },
  methods: {
    // login登录
    async login () {
      if (this.validateInfo()) {
        // 加密密码
        let psd = ''
        if (localStorage.getItem('password' + this.userName)) {
          psd = localStorage.getItem('password' + this.userName)
        } else {
          psd = this.encryptPassword(this.password)
        }
        let KeyData = 'njfy870084' + this.userName + ',froeasy,' + psd
        let params = new URLSearchParams()
        params.append('KeyData', KeyData)
        let suc = await this.$http.post(this.$vue.getData('LOGIN_URL'), params)
        if (suc.data.result === '1') {
          this.userName = suc.data.data.username
          try {
            window.HandleEvent('isLogin', '1')
          } catch (e) {
            console.log('请配合最新智能诊断系统使用')
          }
          this.userId = suc.data.data.id
          // 登录成功将数据放到localStorage中
          localStorage.setItem('account', this.userName)
          localStorage.setItem('userName', this.userName)
          localStorage.setItem('password' + this.userName, psd)
          localStorage.setItem('userId' + this.userName, this.userId)
          localStorage.setItem('laboratoryId', suc.data.data.laboratoryId)
          this.$router.push({name: 'Index'})
        } else {
          this.errorText = this.$t('login.incorrectPasswordTip')
          this.password = ''
          this.isShowError = true
        }
      }
    },
    // 加密密码
    encryptPassword (psd) {
      return hexsha1.hex_sha1(psd)
    },
    // 选择技术员
    selectUser () {
      // 放入当前用户名
      localStorage.setItem('userName', this.userName)
      // 判断是否记住密码
      if (localStorage.getItem('isStore' + this.userName) === 'true') {
        this.isStore = true
        this.password = localStorage.getItem('password' + this.userName)
      } else {
        this.isStore = false
        this.password = ''
      }
    },
    // 记住密码
    rememberPassword () {
      localStorage.setItem('isStore' + this.userName, this.isStore)
    },
    // 获取用户列表
    async getUserNameList () {
      let suc = await this.$http.post(this.$vue.getData('GET_USER_NAME_LIST_URL'))
      if (suc.data.result === '1') {
        this.loginStatus = suc.data.data.loginStatus
        if (this.loginStatus === '1') {
          this.systemName = suc.data.data.systemName
          this.versionNumber = suc.data.data.versionNumber
          this.userList = suc.data.data.userNameList
        } else {
          try {
            window.HandleEvent('isLogin', '1')
          } catch (e) {
            console.log('请配合最新智能诊断系统使用')
          }
          localStorage.removeItem('userName')
          this.$router.push({name: 'Index'})
        }
      }
    },
    // 校验用户名、密码
    validateInfo () {
      if (this.userName === '') {
        this.errorText = this.$t('login.usernamePlaceholder')
        this.isShowError = true
        return false
      } else if (this.password === '') {
        this.errorText = this.$t('login.passwordPlaceholder')
        this.isShowError = true
        return false
      }
      return true
    },
    cancelError () {
      this.isShowError = false
    }
  },
  beforeMount () {
    this.$vue = this
    this.userName = localStorage.getItem('account')
    this.getUserNameList()
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .login-style
    width 100%
    height 100%
    background url("../assets/wpc-bg.png")
    background-repeat no-repeat
    background-size 100% 100%
  .login-content
    position absolute
    width 48%
    height 35%
    top 15%
    left 25%
  .login-card
    width 700px
    margin-top 8%
    padding 25px 0px 25px 10px
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  .error-text
    display inline-block
    text-align left
    width 70%
    margin-top 10px
    padding-left 6px
    color #b74d46
    background-color #fff0f0
    border 1px solid #ffd2d2
    line-height 26px
    font-size 12px
  .login-btn
    padding-top 10%
</style>



// WEBPACK FOOTER //
// src/components/Login.vue